var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumidityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4C13.34 13.1 8 20.96 8 27.6C8 37.56 15.6 44 24 44C32.4 44 40 37.56 40 27.6C40 20.96 34.66 13.1 24 4ZM24 40C17.3 40 12 34.86 12 27.6C12 22.92 15.9 16.72 24 9.32C32.1 16.72 36 22.9 36 27.6C36 34.86 30.7 40 24 40ZM15.66 28C16.4 28 17 28.52 17.14 29.24C17.96 33.68 21.7 35.2 24.42 34.98C25.28 34.94 26 35.62 26 36.48C26 37.28 25.36 37.94 24.56 37.98C20.3 38.24 15.32 35.8 14.18 29.74C14.02 28.84 14.74 28 15.66 28Z",
    fill: "#1C1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidityIcon);
export default __webpack_public_path__ + "static/media/humidityIcon.d7f4f95c6fda0c40c14c9810e7f51964.svg";
export { ForwardRef as ReactComponent };